import * as z from 'zod';

const salesChannelTypeSchema = z.union([
  z.literal('online'),
  z.literal('pointOfSale'),
  z.literal('insideSalesIndividual'),
  z.literal('salesforce'),
  z.literal('customerRep'),
  z.literal('manualEntry'),
  z.literal('reseller'),
  z.literal('kiosk'),
  z.literal('collaborator'),
  z.literal('isv'),
  z.literal('systemProcess'),
]);

export type SalesChannelType = z.infer<typeof salesChannelTypeSchema>;

export const saleChannelSchema = z.object({
  name: z.string(),
  channel: z.string(),
  enabled: z.boolean(),
});

export interface SalesChannel {
  name: SalesChannelType;
  channel: string;
  enabled: boolean;
}
